import React, { useEffect, useState } from 'react';
import styles from './StickyCta.module.scss';

const StickyCta = ({ onOpenPlanner }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hero = document.querySelector('header');
    const onScroll = () => {
      const threshold = hero ? hero.offsetHeight * 0.9 : 600;
      setShow(window.scrollY > threshold);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`${styles.bar} ${show ? styles.show : ''}`}>
      <div className={styles.wrap}>
        <div className={styles.txt}>
          Ready to plan your safari?
          <span>
            <span className={styles.stars}>★★★★★</span> 4.9 · 3 free quotes ·
            reply within 24 hours
          </span>
        </div>
        <button className={styles.btn} onClick={() => onOpenPlanner?.()}>
          Design your Safari  →
        </button>
      </div>
    </div>
  );
};

export default StickyCta;
